import { makeAutoObservable } from "mobx";
import { loadFromStorage, saveToStorage } from "src/common/localStorageApi";

const storageKeys = {
  leftMenuOpen: "leftMenuOpen",
  leftMenuGroupsState: "leftMenuGroupsState",
} as const;

class LeftMenuStore {
  isOpen: boolean = loadFromStorage(storageKeys.leftMenuOpen, false);

  groupsState: Record<string, boolean> = loadFromStorage(
    storageKeys.leftMenuGroupsState,
    {} as Record<string, boolean>,
  );

  constructor() {
    makeAutoObservable(this);
  }

  setIsOpen(flag: boolean) {
    this.isOpen = flag;
    saveToStorage(storageKeys.leftMenuOpen, this.isOpen);
  }

  toggleGroup(groupKey: string) {
    this.groupsState[groupKey] = !this.groupsState[groupKey];
    saveToStorage(storageKeys.leftMenuGroupsState, this.groupsState);
  }

  isGroupOpen(groupKey: string): boolean {
    // По умолчанию группы открыты
    return this.groupsState[groupKey] ?? true;
  }

  close() {
    this.setIsOpen(false);
  }
}

export const leftMenuStore = new LeftMenuStore();
